import { css } from "@emotion/react";
import { fontPretendard } from "@teamsparta/design-system/dist/font/font";

export const WebHeader1 = css`
  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 140%;
  /* identical to box height, or 56px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const WebTitle1 = css`
  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  /* identical to box height, or 34px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const WebTitle2 = css`
  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  /* identical to box height, or 28px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const WebTitle3 = css`
  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 140%;
  /* identical to box height, or 28px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const WebBody1 = css`
  /* Web/Header/Header1_700 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const WebBody2 = css`
  /* Web/Header/Header1_700 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const WebBody3 = css`
  /* Web/Header/Header1_700 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 21px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const WebCaption1 = css`
  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 150%;
  /* identical to box height, or 20px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileHeader0 = css`
  /* Mobile/Header0_700 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 140%;
  /* or 39px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileHeader1 = css`
  /* Mobile/Header1_700 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  /* identical to box height, or 34px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileTitle1 = css`
  /* Mobile/Title1_600 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  /* or 25px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileTitle2 = css`
  /* Mobile/Title2_600 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  /* or 22px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileTitle3 = css`
  /* Mobile/Title3_400 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  /* or 22px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileBody1 = css`
  /* Mobile/Body1_600 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 21px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileBody2 = css`
  /* Mobile/Body2_400 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 21px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileBody3 = css`
  /* Mobile/Body3_400 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 150%;
  /* identical to box height, or 20px */

  /* Gray/Gray100 */

  color: #141617;
`;

export const MobileCaption1 = css`
  /* Mobile/Caption1_400 */

  font-family: ${fontPretendard};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  /* identical to box height, or 18px */

  /* Gray/Gray100 */

  color: #141617;
`;
